var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3C10.22 3 3.5 9.72 3.5 18C3.5 26.28 10.22 33 18.5 33C26.78 33 33.5 26.28 33.5 18C33.5 9.72 26.78 3 18.5 3ZM25.46 13.2C25.235 15.57 24.26 21.33 23.765 23.985C23.555 25.11 23.135 25.485 22.745 25.53C21.875 25.605 21.215 24.96 20.375 24.405C19.055 23.535 18.305 22.995 17.03 22.155C15.545 21.18 16.505 20.64 17.36 19.77C17.585 19.545 21.425 16.05 21.5 15.735C21.5104 15.6873 21.509 15.6378 21.496 15.5907C21.4829 15.5437 21.4585 15.5005 21.425 15.465C21.335 15.39 21.215 15.42 21.11 15.435C20.975 15.465 18.875 16.86 14.78 19.62C14.18 20.025 13.64 20.235 13.16 20.22C12.62 20.205 11.6 19.92 10.835 19.665C9.89 19.365 9.155 19.2 9.215 18.675C9.245 18.405 9.62 18.135 10.325 17.85C14.705 15.945 17.615 14.685 19.07 14.085C23.24 12.345 24.095 12.045 24.665 12.045C24.785 12.045 25.07 12.075 25.25 12.225C25.4 12.345 25.445 12.51 25.46 12.63C25.445 12.72 25.475 12.99 25.46 13.2Z",
    fill: "#4C89FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCTelegram);
export default __webpack_public_path__ + "static/media/c_telegram.48e3773148c060e09e4a1b76c31e8204.svg";
export { ForwardRef as ReactComponent };